module.exports = __webpack_public_path__ + "static/media/sagarmatha.d986ee7b.jpg";